<template>
    <div class="backdrop">
        <div class="modal">
            <h1>{{ modalHeader }}</h1>
                <span class="question-label">ID</span>
                <span class="question-value">{{ criteria_id }}</span>
            <form action="" class="form">
                <div class="form-container">
                    <div class="form-left">
                        <div class="form-group">
                            <div class="field-title">DESCRIPTION</div>
<!--                             <label for="question_description" class="form__label">Description</label>
 -->                            <textarea 
                                :class="['form__editable', { 'disabled': isLocked }]"
                                placeholder="Description"
                                v-model="description"
                                :disabled="isLocked"
                            ></textarea>
                        </div>
                        <div class="form-group">
                            <div class="field-title">AIDE</div>
<!--                             <label for="question_help_text" class="form__label">Aide</label>
 -->                            <textarea 
                                :class="['form__editable', { 'disabled': isLocked }]"
                                placeholder="Aide"
                                v-model="help_text"
                                :="isLocked"
                            ></textarea>
                        </div>
                        <div class="form-group">
                            <div class="field-title">Justificatifs à fournir</div>
<!--                             <label for="question_justification" class="form__label">Justificatifs à fournir</label>
 -->                            <textarea 
                                :class="['form__editable', { 'disabled': isLocked }]"
                                placeholder="Justificatifs à fournir"
                                v-model="justification"
                                :disabled="isLocked"
                            ></textarea>
                        </div>
                        <div class="form-group">
                            <div class="field-title">Documentation</div>
<!--                             <label for="question_documentation" class="form__label">Documentation</label>
 -->                            <textarea 
                                :class="['form__editable', { 'disabled': isLocked }]"
                                placeholder="[Text de documentation](https://exemple.com)"
                                v-model="documentation"
                                :disabled="isLocked"
                            ></textarea>
                        </div>
                        <div>
                            <div class="documentation-display">
                                <span class="criteria-label"  placeholder="[Text de documentation](https://exemple.com)">APERÇU<br></span>
                                <span v-html="htmlContent(documentation)" class="criteria-value"></span>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="field-title">TYPE DE QUESTION</div>
<!--                             <label for="question_type" class="form__label">Type de question</label>
 -->                            <select v-model="question_type" :disabled="isLocked" class="form__select" id="question_type">
                                <option value="QUALITATIVE">Qualitative</option>
                                <option value="QUANTITATIVE-VALUE">Quantitative</option>
                                <option value="FORMULA">Formule</option>
                            </select>
                        </div>
                        <!-- <div class="form-group required-field">
                            <div class="value-checkbox">
                                <input type="checkbox" v-model="mandatory" class="form__checkbox" id="question_mandatory"/>
                                <label for="question_mandatory" class="form__checkbox-label">Obligatoire</label>
                            </div>
                        </div> -->
                        <div class="form-group required-field">
                            <div class="value-checkbox">
                                <input 
                                    type="checkbox" 
                                    :checked="is_evaluated" 
                                    @change="is_evaluated = $event.target.checked" 
                                    :disabled="isLocked" 
                                    class="form__checkbox" 
                                    id="question_evaluated"
                                />
                                <label for="question_evaluated" class="form__checkbox-label">À évaluer</label>
                            </div>
                        </div>
                    </div>
                    <div class="form-right">
                        <div v-if="question_type === 'QUALITATIVE' " class="question-values">
                            <div v-for="(value, index) in question_values" :key="index" class="question-value-item">
                                <div class="value-checkbox">
                                    <input type="checkbox" v-model="value.selected" :disabled="isLocked" class="form__checkbox" :id="'question_type_' + index" />
                                    <label 
                                        :for="'question_type_' + index" 
                                        :class="['label-' + getLabel(index).toLowerCase(), { disabled: !value.selected }]"
                                        >
                                        {{ getLabel(index) }}
                                    </label>
                                </div>
                                <textarea 
                                    v-if="value.selected" 
                                    :disabled="isLocked" 
                                    class="form__editable value-text" 
                                    :placeholder="'objectifs pour le ' + getLabel(index)" 
                                    v-model="value.text">
                                </textarea>
                            </div>
                        </div>
                        <div v-if="question_type === 'QUANTITATIVE-VALUE' || question_type === 'FORMULA'" class="form-group">
                            <div class="field-title">{{ quantitativeTitle }}</div>
                            <div class="form-group" style="margin-bottom: 24px;">
                                <div class="field-tag">TAG</div>
                                <label for="question_tag" class="form__label">TAG</label>
                                <!-- <select v-model="tag" class="form__select" :disabled="isLocked" id="question_tag">
                                    <option value="NONE">Aucun</option>
                                    <option v-for="(value, index) in questionTags" :key="index" :value="value.tag">{{ value.tag }}</option>
                                </select> -->
                                <!-- filepath: c:\Users\Ricardo\Documents\ALRO\front\src\components\admin\QuestionModalEditor.vue -->
                                <multiselect
                                  v-model="tag"
                                  :options="questionTags.map(q => q.tag)"
                                  :searchable="true"
                                  :close-on-select="true"
                                  :clear-on-select="false"
                                  :allow-empty="true"
                                  placeholder="Sélectionner un TAG"
                                  :disabled="isLocked"
                                  class=""
                                  id="question_tag"
                                >
                                  <template #option="props">
                                    <span>{{ props.option }}</span>
                                  </template>
                                </multiselect>
                            </div>
                            <div class="form-group">
                                <div class="field-title">TYPE EVALUATION</div>
                                <label for="evaluation_type" class="form__label">Type d'évaluation</label>
                                <select v-model="evaluation_type" class="form__select" :disabled="isLocked" id="evaluation_type">
                                    <option value="NUMERIC">Numérique</option>
                                    <option value="FORMULA">Formule</option>
                                </select>
                            </div>
                            <div v-for="(value, index) in question_limits" :key="index" class="question-value-item">
                                <div class="value-checkbox">
                                    <input type="checkbox" v-model="value.selected" :disabled="isLocked" class="form__checkbox" :id="'question_type_' + index" />
                                    <select v-model="value.sign" class="form__select" :disabled="isLocked" id="'question_type_' + index">
                                        <!-- <option value=""></option> -->
                                        <option value="gteq">Supérieur ou égal à</option>
                                        <option value="gt">Supérieur à</option>
                                        <option value="lteq">Inférieur ou égal à</option>
                                        <option value="lt">Inférieur à</option>
                                    </select>
                                    <label 
                                        :for="'question_type_' + index" 
                                        :class="['label-' + getLabel(index).toLowerCase(), { disabled: !value.selected }]">
                                        {{ getLabel(index) }}
                                    </label>
                                </div>
                                <textarea 
                                    v-if="value.selected && evaluation_type === 'NUMERIC'" :contenteditable="!isLocked" 
                                    class="form__editable value-text" 
                                    :placeholder="'Valeur limite'"
                                    v-model="value.limit">
                                </textarea>
                                <div v-if="value.selected && evaluation_type === 'FORMULA'" class="value-checkbox">
                                    <label for="evaluation_tag" class="form__label">TAG</label>
                                    <!-- <select v-model="value.limit" class="form__select" :disabled="isLocked" id="evaluation_tag">
                                        <option value="NONE">Aucun</option>
                                        <option v-for="(evalTag, index2) in evaluationTags" :key="index2" :value="evalTag.tag">{{ evalTag.tag }}</option>
                                    </select> -->
                                    <multiselect
                                    v-model="value.limit"
                                    :options="evaluationTags.map(q => q.tag)"
                                    :searchable="true"
                                    :close-on-select="true"
                                    :clear-on-select="false"
                                    :allow-empty="true"
                                    placeholder="Sélectionner un TAG"
                                    :disabled="isLocked"
                                    :id="'evaluation_tag_'+index"
                                    >
                                      <template #option="props">
                                        <span>{{ props.option }}</span>
                                      </template>
                                    </multiselect>
                                    <textarea 
                                    :disabled="isLocked" 
                                    class="form__editable factor" 
                                    :placeholder="'Facteur'"
                                    v-model="value.factor"
                                    >
                                    </textarea>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-actions">
                    <button v-if="!isLocked" @click.prevent="submitForm" class="form__button">{{ submitButton }}</button>
                    <button @click.prevent="closeModal" class="form__button form__button--cancel">Annuler</button>
                </div>
            </form>
        </div>
    </div>
    <LoadingOverlay v-if="loading"/>
</template>


<script>
import { mapGetters, mapState } from 'vuex';
import Multiselect from 'vue-multiselect';
import '../../assets/styles/base.css';
import LoadingOverlay from '../generic/LoadingOverlay.vue';


export default {
    name: "QuestionModalCreator",
    components: {
        Multiselect,
        LoadingOverlay
    },
    computed: {
        ...mapState("referential", ["activeQuestion", "callerObject", "questionTags", "evaluationTags", "selectedReferential", "loading"]),
        ...mapGetters("referential", ["isReferentialLocked", "getMaxLength"]),
        ...mapGetters("project", ["renderedMarkdown"]),
        // htmlContent(text) {
        //     //console.log("htmlContent function called with content: ", this.documentation)
        //     //console.log("or in variable received: ", text)
        //     return this.renderedMarkdown(text);
        // },
        isLocked() {
            if(!this.selectedReferential || this.selectedReferential === 0) {
                return false;
            }
            return this.isReferentialLocked(this.selectedReferential)
        },
        quantitativeTitle() {
            // if(this.question_type === "QUANTITATIVE-VALUE") {
            //     return "Valeur quantitative"
            // } else if(this.question_type === "FORMULA") {
            //     return "Formule"
            // }
            return this.question_type === "QUANTITATIVE-VALUE" ? "VALEUR QUANTITATIVE" : "FORMULE";
        },
    },
    data() {
        return {
            criteria_id: 0,
            default_value: "",
            help_text: "",
            description: "",
            justification: "",
            documentation: "",
            id: 0,
            question_type: "QUALITATIVE",
            // quantitativeTitle: "Valeur quantitative",
            //mandatory: false,
            is_evaluated: true,
            tag: "",
            evalTag_i: "NONE",
            evaluation_type: "NUMERIC",
            question_values: [
                { selected: false, text: "" },
                { selected: false, text: "" },
                { selected: false, text: "" },
                { selected: false, text: "" }
            ],
            question_limits: [
                { selected: false, limit: "", sign: "" },
                { selected: false, limit: "", sign: "" },
                { selected: false, limit: "", sign: "" },
                { selected: false, limit: "", sign: "" }
            ],
            modalHeader: "Création d'une nouvelle question",
            submitButton: "Créer"
        }
    },
    mounted() {
        this.initializeForm(this.activeQuestion);
        document.body.classList.add('modal-open');
    },
    beforeUnmount() {
      document.body.classList.remove('modal-open');
    },
    watch: {
        activeQuestion: {
            handler(nouvelleQuestion) {
            if (nouvelleQuestion && Object.keys(nouvelleQuestion).length > 0) {
                this.initializeForm(nouvelleQuestion);
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        initializeForm(questionData){
            ////console.log("Initializing form with data: ", questionData);
            
            if(this.callerObject && Object.keys(this.callerObject).length > 0) {
                this.criteria_id = this.callerObject.id;
                this.help_text = "";
                this.description = "";
                this.justification = "";
                this.documentation = "";
                this.question_type = "QUALITATIVE";
                this.tag = "";
                this.is_evaluated = true ;
                this.evaluation_type = "NUMERIC";
                //this.mandatory = false;
                this.question_values = this.question_values.map(() => ({ selected: false, text: "" }));
                this.question_limits = this.question_limits.map(() => ({ selected: false, limit: "", sign: "", factor: 1 }));
                this.modalHeader = "Création d'une nouvelle question";
                this.submitButton = "Créer";

            } else if (questionData && Object.keys(questionData).length > 0) {
                ////console.log("Setting values for active question: ", questionData);
                this.criteria_id = questionData.criteria_id;
                this.help_text = questionData.help_text;
                this.description = questionData.description;
                this.justification = questionData.justification;
                this.documentation = questionData?.documentation || "";
                this.question_type = questionData.question_type;
                this.tag = questionData.tag;
                this.is_evaluated = !!questionData.is_evaluated; 
                const evaluated_by_formula = this.question_limits.some(limit => isNaN(limit.limit));
                let evaluation_type_formula = evaluated_by_formula ? "FORMULA" : "NUMERIC";

                this.evaluation_type = evaluation_type_formula;
                /* this.mandatory = questionData.mandatory === 1; */
                
                this.question_values = [0, 1, 2, 3].map(index => ({
                    selected: !!questionData.question_values?.[index],
                    text: questionData.question_values?.[index]?.meaning || ""
                }));
                
                this.question_limits = [0, 1, 2, 3].map(index => {
                    const limitData = questionData.question_limits?.[index];
                    const hasMeaningfulData = limitData && (
                        limitData.sign !== "" &&
                        limitData.limit !== "" /* &&
                        limitData.factor !== "" */
                    );
                    if(!hasMeaningfulData){
                        return{
                            selected: false,
                            factor: 1,
                            sign: "",
                            limit: ""  
                        }
                    }else {
                    return {
                        selected: !!limitData,
                        factor: limitData?.factor || 1,
                        sign: limitData?.sign || "",
                        limit: limitData?.limit || "",
                    };
                }
                });
                
                this.modalHeader = "Éditer une question";
                this.submitButton = "OK";
            } else {
                //console.log("No active data to initialize form.");
            }
            if(this.questionTags.length === 0) {
                this.$store.dispatch("referential/fetchQuestionTags");
            }
            if(this.evaluationTags.length === 0) {
                this.$store.dispatch("referential/fetchEvaluationTags");
            }
        },
        closeModal() {
            ////console.log("closing modal for creating/editing Question")
            this.$store.commit("referential/toggleQuestionModal", false)
            this.$emit('close')
        },
        async submitForm() {
            //console.log("submitting form with limits: ", this.question_limits)
            //const limitsToSend = this.question_limits.filter(limit => limit.selected);
            const limitsToSend = [0,1,2,3].map(index => {
                const limitData = this.question_limits?.[index];
                if(limitData.selected === true){
                    return {
                        selected: !!limitData,
                        factor: limitData?.factor || 1,
                        sign: limitData?.sign || "",
                        limit: limitData?.limit || "",
                    };
                }else {
                    return {
                        selected: false,
                        factor: 1,
                        sign: "",
                        limit: ""
                    }
                }
            })
            try {
                this.$store.commit("referential/loadingMutation", true)
                const evaluated_by_formula = limitsToSend.some(limit => isNaN(limit.limit));
                let evaluation_type = "";
                if (evaluated_by_formula === true){
                    evaluation_type = "FORMULA"
                } else if (evaluated_by_formula === false){
                    evaluation_type = "NUMERIC"
                }
                if(this.callerObject && Object.keys(this.callerObject).length > 0) {
                    await this.$store.dispatch("referential/questionInsert", {
                        criteria_id: parseInt(this.criteria_id),
                        help_text: this.help_text,
                        description: this.description,
                        justification: this.justification,
                        question_type: this.question_type,
                        question_values: this.question_values,
                        //mandatory: this.mandatory,
                        question_limits: limitsToSend,
                        is_evaluated: this.is_evaluated,
                        tag: this.tag,
                        evaluated_by_formula: evaluation_type,
                        documentation: this.documentation,
                    })
                    // To avoid conflict when you open a question right after creating another one, you set the callerSetMutation empty
                    this.$store.commit("referential/callerSetMutation", {})
                } else if (this.activeQuestion && Object.keys(this.activeQuestion).length > 0) {
                    await this.$store.dispatch("referential/questionUpdate", {
                        criteria_id: parseInt(this.criteria_id),
                        help_text: this.help_text,
                        description: this.description,
                        justification: this.justification,
                        question_type: this.question_type,
                        question_values: this.question_values,
                        //mandatory: this.mandatory,
                        id: this.activeQuestion.id,
                        question_limits: limitsToSend,
                        is_evaluated: this.is_evaluated,
                        tag: this.tag,
                        evaluated_by_formula: evaluation_type,
                        documentation: this.documentation,
                    })
                    //console.log(typeof this.evaluated_by_formula);
                }
                this.$store.commit("referential/makeCriteriaActiveMutation", [])
                this.$store.commit("referential/loadingMutation", false)
                this.closeModal()
            } catch (error) {
                console.error("Error submiting criteria", error)
            }
            this.$store.commit("referential/makeQuestionActiveMutation", [])
            this.closeModal()
        },
        getLabel(index) {
            switch(index) {
                case 0: return "Noir";
                case 1: return "Rouge";
                case 2: return "Jaune";
                case 3: return "Vert";
                default: return "";
            }
        },
        htmlContent(text) {
            /* //console.log("htmlContent function called with content: ", this.documentation)
            //console.log("or in variable received: ", text) */
            if(this.documentation == '' || this.documentation == null) {
                text = "[Text de documentation]&#8203;(https://exemple.com)";
                /* return text; */
            }
            return this.renderedMarkdown(text);
        },
    }
};
</script>

<style scoped>
.backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 107%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.modal {
    background: white;
    padding: 25px 30px;
    border-radius: 8px;
    max-width: 1500px;
    width: 95%;
    box-shadow: 0 4px 12px rgba(253, 26, 50, 0.15);
    max-height: 75vh;
    overflow-y: 10px;
    transition: all 0.3s ease;
}

h1 {
    text-align: center;
    margin-bottom: 25px;
    color: #333;
    font-size: 24px;
    font-weight: bold;
}

.form {
    display: flex;
    flex-direction: column;
    max-width: 1500px;
}

.form-container {
    display: flex;
    max-width: 1600px;
    width: 100%;
    gap: 40px;
}

.form-left, .form-right {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 20px;
}
.form-left{
    min-width: 65%;
}

.form-right {
    background: #f8f8f8;
    max-width: 35%;
    padding: 25px;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}


.form-group {
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    transition: transform 0.3s ease;
}

/* .form-group:hover {
    transform: translateX(5px);
} */
.form__select:hover, .form__editable:hover, input:hover{
    box-shadow: 0 4px 8px var(--left4-color);
}

.field-title {
    font-weight: 600;
    color: #333;
    font-size: 14px;
    text-align: center;
    margin-bottom: 8px;
    text-transform: uppercase;
}

.form__label {
    display: none;
}

.form__input,
.form__select,
.form__editable {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid #e4e4e4;
    border-radius: 6px;
    box-sizing: border-box;
    font-size: 16px;
    transition: all 0.3s ease;
    background-color: #ffffff;
    box-shadow: 0 2px 4px rgba(0,0,0,0.03);
}

.form__editable {
    min-height: 68px;
    line-height: 1.4;
    outline: none;
    overflow-wrap: break-word;
    word-wrap: break-word;
    white-space: pre-wrap;
}
.factor{
    display: flex;
    justify-content: flex-end;
    min-height: 32px;
    max-width: 3vw;
}

.criteria-id-display {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 20px;
    padding: 8px;
    background: #f8f8f8;
    border-radius: 4px;
    width: fit-content;
}

.criteria-label, .question-label {
    font-size: 0.9rem;
    font-weight: bold;
    color: #666;
    text-transform: uppercase;
}

.criteria-value, .question-value {
    font-size: 1.1rem;
    font-weight: bold;
    color: #2c3e50;
    padding: 4px 8px;
    background: #fff;
    border-radius: 4px;
}

/* Style for placeholder in editables */
.form__editable:empty:before {
    content: attr(placeholder);
    color: #888;
    pointer-events: none;
}
.form__editable.disabled {
    pointer-events: none;
    background-color: #f9f9f9;
    color: #aaa;
}
.form__input:focus,
.form__select:focus,
.form__editable:focus {
    outline: none;
    border-color: var(--primary-color);
}

.question-values {
    margin-top: 15px;
}

.question-value-item {
    margin-bottom: 15px;
    transition: transform 0.3s ease;
}

/* .question-value-item:hover {
    transform: translateX(5px);
} */

.value-checkbox {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
}

.form__checkbox {
    margin-right: 10px;
    width: 18px;
    height: 18px;
    cursor: pointer;
}

.form__checkbox-label {
    font-weight: 600;
    color: #333;
}
input[type="checkbox"]:checked {
  accent-color: var(--primary-color);
}

.required-field {
    margin-top: 10px;
    border-top: 1px solid #e4e4e4;
    padding-top: 15px;
}

.value-text {
    width: 100%;
    border: 1px solid #e4e4e4;
    border-radius: 6px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.03);
}

.label-noir,
.label-rouge,
.label-jaune,
.label-vert {
    padding: 8px 12px;
    border-radius: 4px;
    font-size: 14px;
    margin-right: 10px;
    font-weight: bold;
    display: inline-block;
    min-width: 70px;
    text-align: center;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.label-noir {
    background-color: #333;
    color: white;
}

.label-rouge {
    background-color: #cc1528;
    color: white;
}

.label-jaune {
    background-color: #ffc107;
    color: #333;
}

.label-vert {
    background-color: #28a745;
    color: white;
}
.label-noir:hover {
    box-shadow: 0 4px 8px #3333334b;
}

.label-rouge:hover {
    box-shadow: 0 4px 8px #cc15277e;
}

.label-jaune:hover {
    box-shadow: 0 4px 8px #ffc1077e;
}

.label-vert:hover {
    box-shadow: 0 4px 8px #28a7467d;
}

.form-actions {
    display: flex;
    justify-content: center;
    gap: 15px;
    margin-top: 25px;
}
.label-noir.disabled,
.label-rouge.disabled,
.label-jaune.disabled,
.label-vert.disabled { 
  background-color: #cccccc;
  box-shadow: 0 4px 8px #cccccc;
  color: #666666;
}

.form__button {
    padding: 10px 25px;
    background-color: var(--primary-color);
    color: white;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-weight: bold;
    font-size: 14px;
    min-width: 100px;
    transition: all 0.2s ease;
    box-shadow: 0 2px 4px rgba(253,26,50,0.2);
}

.form__button:hover {
    background-color: var(--left2-color);
    box-shadow: 0 4px 8px var(--left2-color);
}

.form__button--cancel {
    background-color: #f1f1f1;
    color: #333;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.form__button--cancel:hover {
    background-color: #e0e0e0;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0,0,0,0.15);
}

#question_type_0, #question_type_1, #question_type_2, #question_type_3 {
    display: none;
}
/* :deep(.multiselect__content) {
  z-index: 99999 !important;
} */
:deep(.multiselect__input), :deep(.multiselect__single) {
    border: none;
    border-radius: none
}
:deep(.multiselect__content-wrapper), :deep(.multiselect__tags) {
    width: 90% !important;
}
:deep(.multiselect__option){
    min-width: 130% !important ;
}
.documentation-display {
  
  max-width: 100%;
  box-sizing: border-box;
}
.criteria-value {
  word-break: break-word;
}
</style>